import {
  LayoutDashboard, Receipt, Trash2, BarChart3, Settings, Building2, FileText, TrendingUp, Award, Users,
} from 'lucide-react';
import { Permission } from '@/types/auth';
import { type NavItem } from './navigation-types';

export const financeNavItems: NavItem[] = [
  {
    id: 'finance',
    label: 'Finance',
    href: '/finance',
    icon: Receipt,
    permissions: [Permission.VIEW_INVOICES],
    children: [
      {
        id: 'finance-invoices',
        label: 'Invoices',
        href: '/finance/invoices',
        icon: Receipt,
        permissions: [Permission.VIEW_INVOICES] 
      },
      {
        id: 'finance-payments',
        label: 'Payments',
        href: '/finance/payments',
        icon: Receipt,
        permissions: [Permission.MANAGE_INVOICES] 
      },
      {
        id: 'finance-spend',
        label: 'Spend Analytics',
        href: '/finance/spend',
        icon: TrendingUp,
        permissions: [Permission.VIEW_SPEND] 
      },
    ],
  },
  {
    id: 'waste',
    label: 'Waste',
    href: '/waste',
    icon: Trash2,
    permissions: [Permission.LOG_WASTE, Permission.VIEW_WASTE],
    children: [
      {
        id: 'waste-log',
        label: 'Log Waste',
        href: '/waste/log',
        icon: Trash2,
        permissions: [Permission.LOG_WASTE] 
      },
      {
        id: 'waste-reports',
        label: 'Reports',
        href: '/waste/reports',
        icon: BarChart3,
        permissions: [Permission.VIEW_WASTE] 
      },
    ],
  },
  {
    id: 'reports',
    label: 'Reports',
    href: '/reports',
    icon: BarChart3,
    permissions: [Permission.VIEW_ANALYTICS],
    children: [
      {
        id: 'reports-dashboards',
        label: 'Dashboards',
        href: '/reports/dashboards',
        icon: LayoutDashboard,
        permissions: [Permission.VIEW_ANALYTICS] 
      },
      {
        id: 'reports-kpis',
        label: 'KPIs',
        href: '/reports/kpis',
        icon: TrendingUp,
        permissions: [Permission.VIEW_ANALYTICS] 
      },
      {
        id: 'reports-compliance',
        label: 'Compliance',
        href: '/reports/compliance',
        icon: FileText,
        permissions: [Permission.VIEW_ANALYTICS] 
      },
    ],
  },
  {
    id: 'performance',
    label: 'Performance',
    href: '/performance',
    icon: Award,
    permissions: [Permission.VIEW_ANALYTICS],
    children: [
      {
        id: 'performance-feedback',
        label: 'Feedback',
        href: '/performance/feedback',
        icon: FileText,
        permissions: [Permission.VIEW_ANALYTICS] 
      },
      {
        id: 'performance-reviews',
        label: 'Reviews',
        href: '/performance/reviews',
        icon: BarChart3,
        permissions: [Permission.VIEW_ANALYTICS] 
      },
      {
        id: 'performance-goals',
        label: 'Goals',
        href: '/performance/goals',
        icon: TrendingUp,
        permissions: [Permission.VIEW_ANALYTICS] 
      },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    href: '/settings',
    icon: Settings,
    permissions: [Permission.MANAGE_USERS],
    children: [
      {
        id: 'settings-org',
        label: 'Organization',
        href: '/settings/organization',
        icon: Building2,
        permissions: [Permission.MANAGE_USERS] 
      },
      {
        id: 'settings-sites',
        label: 'Sites',
        href: '/settings/sites',
        icon: Building2,
        permissions: [Permission.MANAGE_USERS] 
      },
      {
        id: 'settings-users',
        label: 'Users',
        href: '/settings/users',
        icon: Users,
        permissions: [Permission.MANAGE_USERS] 
      },
    ],
  },
];
